import { useState } from 'react'
import { useAlert } from 'react-alert'

import { resetTestes } from '../../../../main/usecases'

import { useOnChangeDetect, useModalBox } from '../../../contexts'
import { Button } from '../../../components'

const DeleteTestesModal = ({ cdTypeToService, cdTeste }: any) => {
  const [loading, setLoading] = useState(false)
  const { modalClose } = useModalBox()
  const alert = useAlert()
  const { setRefresh } = useOnChangeDetect()

  const handleDeleteCustomer = async (
    cdTypeToService: number,
    cdTeste: number
  ) => {
    try {
      setLoading(true)
      await resetTestes({
        cdTypeToService: cdTypeToService,
        cdTeste: cdTeste
      }).load()
      modalClose(true)
      alert.show('Testes personalizado deletado com sucesso', {
        type: 'success',
        timeout: 4000
      })
      setRefresh((prev: any) => !prev)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao deletar o Testes personalizado', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="delete-modal">
      <p>Deseja realmente deletar o teste personalizado?</p>
      <div>
        <Button
          disabled={loading}
          hasredButton
          onClick={() => handleDeleteCustomer(cdTypeToService, cdTeste)}
        >
          Sim
        </Button>
        <Button hasSecodaryButton onClick={modalClose}>
          Não
        </Button>
      </div>
    </div>
  )
}

export default DeleteTestesModal
